import React, {Component} from "react";


class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false , error : {} };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.    
    return { hasError: true, error : error };
  }

  //  componentDidCatch(error, errorInfo) will give us access to the frontend error trace

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <p>Something went wrong</p>
    }

    return this.props.children; 
  }
}

export default ErrorBoundary
